const apiClient = require('../graphql/apiClient')
const { hideRadarArea, isViewEnabled, initialisePage, hideLoader, getRootContent } = require('../utils/headers')
const { getCellColor, getTableHeadingRow, findLastPublishedRecord } = require('../utils/formattingUtils')

const _ = require('lodash')

const { gql } = require('graphql-tag')

const CORE_QUERY = gql`
  query coreStack($statuses: [Status]) {
    blips(statuses: $statuses) {
      id
      name
      link
      labels
      quadrant {
        name
      }
      updated
      history {
        publicationName
        status
      }
    }
  }
`

const VIEW_MODE = 'core'

function renderView() {
  if (isViewEnabled(VIEW_MODE)) {
    hideRadarArea()

    initialisePage('Core Stack', 'Blips which are a core building block within World Kinect Technology')

    let bodyText = ''

    apiClient(CORE_QUERY, {
      statuses: ['CORE'],
    })
      .then((res) => res.json())
      .then((result) => {
        const data = result.data.blips
        const sortedData = _.sortBy(data, ['quadrant.name', 'name'])
        const groupedBlips = _(sortedData)
          .groupBy((blip) => blip.quadrant.name)
          .value()

        bodyText += '<table>'
        bodyText += getTableHeadingRow(groupedBlips)
        bodyText += '<tr>'

        colorIndex = 0

        _.map(groupedBlips, function (value, key) {
          bodyText += `<td style="background-color: ${getCellColor(colorIndex)};">`

          _.each(value, function (blip) {
            let lastSeen = findLastPublishedRecord(blip)

            bodyText += `<div>
              <a href="${blip.link}" target="_blank">${blip.id}</a>: ${blip.name}<br />
              <div style="margin-left: 5px;">
                  <font size="2">
                    <div><strong>Core Building Block: </strong><i> on ${new Date(blip.updated).toDateString()}</i></div>`

            if (lastSeen) {
              bodyText += `<strong>Last Publication: </strong><i>${lastSeen.publicationName} as ${lastSeen.status}</i>`
            }

            bodyText += `<div><strong>Labels: </strong><i>${blip.labels.join(", ")}</i></div>
                  </font >
                </div >
              </div>
            <br />`
          })
          colorIndex += 1
          bodyText += '</td>'
        })

        bodyText += '</tr></table>'
      })
      .then(() => {
        hideLoader()
        getRootContent().append('div').attr('id', 'radar-table').append('div').attr('id', 'core-blips').html(bodyText)
      })
  }
}

module.exports = renderView
